// define a mixin object
const hashtagTableManagement = {
    methods: {
        /**
         * SECTION - Sort the hashtag results table and keep the badge next to the hashtag itself
         * @param {First element} a
         * @param {Second element} b
         * @param {The column we are sorting on} key
         */
        customTableSort(a, b, key) {
            if (key == "hashtagsBadged") {
                return a.hashtag.toString().localeCompare(b.hashtag.toString());
            } else {
                return false;
            }
        },

        /**
         * SECTION - Return colour code for hashtags based on a number of parameters
         */
        returnHashtagRowColour(likesInput, currentItem) {
            // Check if we actually have avg likes
            if (currentItem.avgAvgLikes != 0) {
                // Check if the hashtag is not banned
                if (currentItem.status != "banned") {
                    // CASE - Check for EASY hashtags
                    // More likes than average likes
                    if (likesInput > currentItem.avgAvgLikes) {
                        return "success";

                        // CASE - Check for MEDIUM hashtags
                        // Between 70% of min hashtags and 130% of average hashtags
                    } else if (
                        likesInput > currentItem.avgMinLikes * 0.7 &&
                        likesInput < currentItem.avgAvgLikes * 1.3
                    ) {
                        return "warning";

                        // CASE - Check for HARD hashtags
                        // Smaller than 70% of avg min likes
                    } else if (likesInput <= currentItem.avgMinLikes * 0.7) {
                        return "danger";

                        // CASE - Check for EASY hashtags
                        // All other hashtags
                    } else {
                        return "success";
                    }
                }
            }

            // CASE - All other situations, return null
            return null;
        },
    },
};

// Export
export default hashtagTableManagement;
